import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SuggestionService } from '../../shared-services/suggestion-service/suggestion.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

export interface SuggestionItem {
  id: number,
  title: string,
  price: string,
  slug: string,
  photo: string
}

@Component({
  selector: 'app-input-city',
  templateUrl: './input-city.component.html',
  styleUrl: './input-city.component.scss'
})
export class InputCityComponent implements OnChanges {
  @Input() placeholder = 'Поиск...';
  @Input() control = new FormControl();
  @Input() customClasses = '';

  newItems: any;

  searchResults: SuggestionItem[] = [];
  searchQuery = '';
  isDropdownVisible = false;
  private unsubscribe$ = new Subject();

  constructor(private suggestionService: SuggestionService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items']) {
    }
  }

  onSearch(event: Event): void {
    this.searchQuery = (event.target as HTMLInputElement).value.trim();

    if (this.searchQuery.length > 2) {
      this.isDropdownVisible = true;
      this.searchResults = this.findMatches(this.searchQuery);
    } else {
      this.isDropdownVisible = false;
      this.searchResults = [];
    }
  }

  findMatches(query: string): any {
    const queryParts = query.split(',').map(part => part.trim()).filter(part => part);
    return this.suggestionService.getSuggestions(queryParts.join('&')).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      console.log(res);
    });
  }

  highlightMatch(text: string, query: string): string {
    if (!query) return text;

    const queryParts = query.split(',').map(part => part.trim()).filter(part => part);
    let highlightedText = text;

    queryParts.forEach(part => {
      const regex = new RegExp(`(${part})`, 'gi');

      highlightedText = highlightedText.replace(regex, '<b>$1</b>');
    });

    return highlightedText;
  }

  // onSelect(result: City): void {
  //   this.searchQuery = `${result.city}, ${result.state}`;
  //   this.searchResults = [];
  //   this.isDropdownVisible = false;
  // }

  onFocus(): void {
    if (this.searchResults.length > 0) {
      this.isDropdownVisible = true;
    }
  }
}
